<template>
  <div class="button-progress">
    <button
      type="button"
      class="btn"
    >
      <IconProgressUnconfirm
        width="25px"
        height="25px"
      />
    </button>
  </div>
</template>

<script>
import IconProgressUnconfirm from "@/components/atoms/icons/IconProgressUnconfirm.vue"

export default {
  name: "ButtonProgress",
  components: {
    IconProgressUnconfirm,
  },
}
</script>